// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.table {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  overflow: hidden;
}

.content-header {
  font-style: normal;
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 27px;
  padding: 19px 0px 14px 0px;
}

.modal-title {
  font-style: normal;
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 27px;
  color: #252929;
  text-align: left;
  padding-left: 20px;
}

#btn_cancel_his {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 10px;
  width: 160px;
  height: 37px;
  background: #FFFFFF;
  border: 1px solid #E3EAE6;
  border-radius: 4px;
  flex: none;
  order: 0;
  flex-grow: 0;
}

#btn_save_his {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  padding: 10px;
  gap: 10px;
  width: 160px;
  height: 37px;
  background: #E3EAE6;
  border-radius: 4px;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.head-text {
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  line-height: 100%;
  display: flex;
  align-items: center;
  color: #252929;
  padding: 5px;
}

.cus-margin {
  margin-left: 20px;
}

.item {
  float: left;
  padding: 10px;
  border: none;
  justify-content: space-between;
}

.modal-footer.btn-div {
  clear: both;
}

.form-control.notes {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 12px;
  gap: 100px;
  background: #FFFFFF;
  border: 1px solid #D0D2D3;
  border-radius: 4px;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 1;
}

.title-body {
  color: #0ba408;
}

.title-header {
  margin: 20px 20px 0 20px;
}

.body {
  border: 1px solid #dee2e6;
  border-radius: 5px;
  margin: 20px;
}

.red-container {
  width: 15px;
  height: 15px;
  background-color: red;
  border-radius: 3px;
  margin: 1px 0 0 5%;
}

.grey-container {
  width: 15px;
  height: 15px;
  background-color: #cdcdcd;
  border-radius: 3px;
  margin: 1px 0 0 2%;
}

th {
  white-space: normal !important;
  min-width: 4rem;
  text-align: center !important;
}

:host .modal-header {
  position: relative;
  padding-top: 18px;
}
:host .modal-header .btn-close {
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: default;
}
:host .modal-header .close-custom {
  justify-content: flex-end;
  cursor: pointer;
}
:host .modal-header .close-custom :hover {
  background: none !important;
}
:host .modal-header .sidebar-act-icon {
  display: flex;
  color: #707070;
}
:host .modal-header .sidebar-act-icon .sidebar-close {
  cursor: pointer;
  display: flex;
  align-items: center;
}
:host .modal-header .sidebar-act-icon .sidebar-expand {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 1em;
}
:host .modal-body {
  max-height: calc(100vh - 120px);
  padding-top: 18px;
  padding-right: 25px;
}
:host .modal-body .task-list table tbody {
  height: 245px;
  overflow-y: auto;
}
:host .modal-footer {
  padding-right: 25px;
  position: sticky;
  bottom: 0;
  right: 0;
  background: #fff;
  width: 100%;
  border-top: 1px solid #dee2e6 !important;
}
:host .modal-footer .btn {
  margin-left: 10px;
}

::ng-deep #serial-detail-prod {
  text-align: right;
}
::ng-deep #serial-detail-prod .item-wrapper:first-child {
  text-align: left;
}
::ng-deep #serial-detail-prod .item-wrapper .content {
  word-break: break-word !important;
  overflow-wrap: break-word !important;
}
::ng-deep .bold-text {
  font-weight: 700;
}
::ng-deep .limited-item-table {
  height: 61vh;
}
::ng-deep .limited-item-table th {
  position: sticky;
  top: -1px;
}

.modal-title {
  font-style: normal;
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 27px;
  color: #252929;
  text-align: left;
  padding-left: 20px;
}

#btn_cancel_his {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
  gap: 10px;
  width: 160px;
  height: 37px;
  background: #FFFFFF;
  border: 1px solid #E3EAE6;
  border-radius: 4px;
  flex: none;
  order: 0;
  flex-grow: 0;
}

#btn_save_his {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  padding: 10px;
  gap: 10px;
  width: 160px;
  height: 37px;
  background: #E3EAE6;
  border-radius: 4px;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.head-text {
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  line-height: 100%;
  display: flex;
  align-items: center;
  color: #252929;
  padding: 5px;
}

.cus-margin {
  margin-left: 20px;
}

.item {
  float: left;
  padding: 10px;
  border: none;
  justify-content: space-between;
}

.modal-footer.btn-div {
  clear: both;
}

.form-control.notes {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 12px;
  gap: 100px;
  background: #FFFFFF;
  border: 1px solid #D0D2D3;
  border-radius: 4px;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 1;
}

.title-body {
  color: #0ba408;
}

.title-header {
  margin: 20px 20px 0 20px;
}

.body {
  border: 1px solid #dee2e6;
  border-radius: 5px;
  margin: 20px;
}

.red-container {
  width: 15px;
  height: 15px;
  background-color: red;
  border-radius: 3px;
  margin: 1px 0 0 5%;
}

.grey-container {
  width: 15px;
  height: 15px;
  background-color: #cdcdcd;
  border-radius: 3px;
  margin: 1px 0 0 2%;
}

th {
  white-space: normal !important;
  min-width: 4rem;
  text-align: center !important;
}

:host .modal-header {
  position: relative;
  padding-top: 18px;
}
:host .modal-header .btn-close {
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: default;
}
:host .modal-header .close-custom {
  justify-content: flex-end;
  cursor: pointer;
}
:host .modal-header .close-custom :hover {
  background: none !important;
}
:host .modal-header .sidebar-act-icon {
  display: flex;
  color: #707070;
}
:host .modal-header .sidebar-act-icon .sidebar-close {
  cursor: pointer;
  display: flex;
  align-items: center;
}
:host .modal-header .sidebar-act-icon .sidebar-expand {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-right: 1em;
}
:host .modal-body {
  padding-top: 18px;
  padding-right: 25px;
}
:host .modal-body .task-list table tbody {
  height: 245px;
  overflow-y: auto;
}
:host .modal-footer {
  padding-right: 25px;
  position: sticky;
  bottom: 0;
  right: 0;
  background: #fff;
  width: 100%;
  border-top: 1px solid #dee2e6 !important;
}
:host .modal-footer .btn {
  margin-left: 10px;
}

::ng-deep #serial-detail-prod {
  text-align: right;
}
::ng-deep #serial-detail-prod .item-wrapper:first-child {
  text-align: left;
}
::ng-deep #serial-detail-prod .item-wrapper .content {
  word-break: break-word !important;
  overflow-wrap: break-word !important;
}
::ng-deep .bold-text {
  font-weight: 700;
}
::ng-deep .limited-item-table {
  height: 61vh;
}
::ng-deep .limited-item-table th {
  position: sticky;
  top: -1px;
}

.btn {
  min-width: 115px;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/all-modules/team/components/team-change-history/team-change-history.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,8BAAA;EACA,+BAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,0BAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,8BAAA;AACF;;AAMA;EACE,WAAA;AAHF;;AAMA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;AAHF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE,wBAAA;AAJF;;AAOA;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AAJF;;AAOA;EACE,8BAAA;EACA,eAAA;EACA,6BAAA;AAJF;;AAQE;EACE,kBAAA;EACA,iBAAA;AALJ;AAOI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AALN;AAQI;EACE,yBAAA;EACA,eAAA;AANN;AAQM;EACE,2BAAA;AANR;AAUI;EACE,aAAA;EACA,cAAA;AARN;AAUM;EACE,eAAA;EACA,aAAA;EACA,mBAAA;AARR;AAWM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AATR;AAcE;EACE,+BAAA;EACA,iBAAA;EACA,mBAAA;AAZJ;AAgBQ;EACE,aAAA;EACA,gBAAA;AAdV;AAoBE;EACE,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,wCAAA;AAlBJ;AAoBI;EACE,iBAAA;AAlBN;;AAwBE;EACE,iBAAA;AArBJ;AAuBI;EACE,gBAAA;AArBN;AAyBM;EACE,iCAAA;EACA,oCAAA;AAvBR;AA4BE;EACE,gBAAA;AA1BJ;AA6BE;EACE,YAAA;AA3BJ;AA+BE;EACE,gBAAA;EACA,SAAA;AA7BJ;;AAkCA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AA/BF;;AAkCA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;AA/BF;;AAkCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;AA/BF;;AAkCA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;AA/BF;;AAkCA;EACE,iBAAA;AA/BF;;AAkCA;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,8BAAA;AA/BF;;AAsCA;EACE,WAAA;AAnCF;;AAsCA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;AAnCF;;AAuCA;EACE,cAAA;AApCF;;AAuCA;EACE,wBAAA;AApCF;;AAuCA;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;AApCF;;AAuCA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AApCF;;AAuCA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AApCF;;AAuCA;EACE,8BAAA;EACA,eAAA;EACA,6BAAA;AApCF;;AAwCE;EACE,kBAAA;EACA,iBAAA;AArCJ;AAuCI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;AArCN;AAwCI;EACE,yBAAA;EACA,eAAA;AAtCN;AAwCM;EACE,2BAAA;AAtCR;AA0CI;EACE,aAAA;EACA,cAAA;AAxCN;AA0CM;EACE,eAAA;EACA,aAAA;EACA,mBAAA;AAxCR;AA2CM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAzCR;AA8CE;EACE,iBAAA;EACA,mBAAA;AA5CJ;AAgDQ;EACE,aAAA;EACA,gBAAA;AA9CV;AAoDE;EACE,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,wCAAA;AAlDJ;AAoDI;EACE,iBAAA;AAlDN;;AAwDE;EACE,iBAAA;AArDJ;AAuDI;EACE,gBAAA;AArDN;AAyDM;EACE,iCAAA;EACA,oCAAA;AAvDR;AA4DE;EACE,gBAAA;AA1DJ;AA6DE;EACE,YAAA;AA3DJ;AA+DE;EACE,gBAAA;EACA,SAAA;AA7DJ;;AAmEA;EACE,gBAAA;AAhEF;AACA,gzdAAgzd","sourcesContent":[".header-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.table {\n  border-top-left-radius: .5rem;\n  border-top-right-radius: .5rem;\n  overflow: hidden;\n}\n\n.content-header {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1.2rem;\n  line-height: 27px;\n  padding: 19px 0px 14px 0px;\n}\n\n.modal-title {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1.2rem;\n  line-height: 27px;\n  color: #252929;\n  text-align: left;\n  padding-left: 20px;\n}\n\n#btn_cancel_his {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n  gap: 10px;\n  width: 160px;\n  height: 37px;\n  background: #FFFFFF;\n  border: 1px solid #E3EAE6;\n  border-radius: 4px;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n#btn_save_his {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: flex-end;\n  padding: 10px;\n  gap: 10px;\n  width: 160px;\n  height: 37px;\n  background: #E3EAE6;\n  border-radius: 4px;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n}\n\n.head-text {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1rem;\n  line-height: 100%;\n  display: flex;\n  align-items: center;\n  color: #252929;\n  padding: 5px;\n}\n\n.cus-margin {\n  margin-left: 20px;\n}\n\n.item {\n  float: left;\n  padding: 10px;\n  border: none;\n  justify-content: space-between;\n}\n\n.form-group.contact-date {\n\n}\n\n.modal-footer.btn-div {\n  clear: both;\n}\n\n.form-control.notes {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 12px;\n  gap: 100px;\n  background: #FFFFFF;\n  border: 1px solid #D0D2D3;\n  border-radius: 4px;\n  flex: none;\n  order: 1;\n  align-self: stretch;\n  flex-grow: 1;\n}\n\n\n.title-body {\n  color: #0ba408;\n}\n\n.title-header {\n  margin: 20px 20px 0 20px;\n}\n\n.body {\n  border: 1px solid #dee2e6;\n  border-radius: 5px;\n  margin: 20px;\n}\n\n.red-container {\n  width: 15px;\n  height: 15px;\n  background-color: red;\n  border-radius: 3px;\n  margin: 1px 0 0 5%;\n}\n\n.grey-container {\n  width: 15px;\n  height: 15px;\n  background-color: #cdcdcd;\n  border-radius: 3px;\n  margin: 1px 0 0 2%;\n}\n\nth {\n  white-space: normal !important;\n  min-width: 4rem;\n  text-align: center !important;\n}\n\n:host {\n  .modal-header {\n    position: relative;\n    padding-top: 18px;\n\n    .btn-close {\n      position: absolute;\n      top: 16px;\n      right: 16px;\n      cursor: default;\n    }\n\n    .close-custom {\n      justify-content: flex-end;\n      cursor: pointer;\n\n      & :hover {\n        background: none !important;\n      }\n    }\n\n    .sidebar-act-icon {\n      display: flex;\n      color: #707070;\n\n      .sidebar-close {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n      }\n\n      .sidebar-expand {\n        display: flex;\n        align-items: center;\n        cursor: pointer;\n        margin-right: 1em;\n      }\n    }\n  }\n\n  .modal-body {\n    max-height: calc(100vh - 120px);\n    padding-top: 18px;\n    padding-right: 25px;\n\n    .task-list {\n      table {\n        tbody {\n          height: 245px;\n          overflow-y: auto;\n        }\n      }\n    }\n  }\n\n  .modal-footer {\n    padding-right: 25px;\n    position: sticky;\n    bottom: 0;\n    right: 0;\n    background: #fff;\n    width: 100%;\n    border-top: 1px solid #dee2e6 !important;\n\n    .btn {\n      margin-left: 10px;\n    }\n  }\n}\n\n::ng-deep {\n  #serial-detail-prod {\n    text-align: right;\n\n    .item-wrapper:first-child {\n      text-align: left;\n    }\n\n    .item-wrapper {\n      .content {\n        word-break: break-word !important;\n        overflow-wrap: break-word !important;\n      }\n    }\n  }\n\n  .bold-text {\n    font-weight: 700;\n  }\n\n  .limited-item-table {\n    height: 61vh;\n    //border-right: 1px solid #E8E8E8;\n  }\n\n  .limited-item-table th {\n    position: sticky;\n    top: -1px;\n  }\n\n}\n\n.modal-title {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1.2rem;\n  line-height: 27px;\n  color: #252929;\n  text-align: left;\n  padding-left: 20px;\n}\n\n#btn_cancel_his {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n  gap: 10px;\n  width: 160px;\n  height: 37px;\n  background: #FFFFFF;\n  border: 1px solid #E3EAE6;\n  border-radius: 4px;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n#btn_save_his {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: flex-end;\n  padding: 10px;\n  gap: 10px;\n  width: 160px;\n  height: 37px;\n  background: #E3EAE6;\n  border-radius: 4px;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n}\n\n.head-text {\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1rem;\n  line-height: 100%;\n  display: flex;\n  align-items: center;\n  color: #252929;\n  padding: 5px;\n}\n\n.cus-margin {\n  margin-left: 20px;\n}\n\n.item {\n  float: left;\n  padding: 10px;\n  border: none;\n  justify-content: space-between;\n}\n\n.form-group.contact-date {\n\n}\n\n.modal-footer.btn-div {\n  clear: both;\n}\n\n.form-control.notes {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 12px;\n  gap: 100px;\n  background: #FFFFFF;\n  border: 1px solid #D0D2D3;\n  border-radius: 4px;\n  flex: none;\n  order: 1;\n  align-self: stretch;\n  flex-grow: 1;\n}\n\n\n.title-body {\n  color: #0ba408;\n}\n\n.title-header {\n  margin: 20px 20px 0 20px;\n}\n\n.body {\n  border: 1px solid #dee2e6;\n  border-radius: 5px;\n  margin: 20px;\n}\n\n.red-container {\n  width: 15px;\n  height: 15px;\n  background-color: red;\n  border-radius: 3px;\n  margin: 1px 0 0 5%;\n}\n\n.grey-container {\n  width: 15px;\n  height: 15px;\n  background-color: #cdcdcd;\n  border-radius: 3px;\n  margin: 1px 0 0 2%;\n}\n\nth {\n  white-space: normal !important;\n  min-width: 4rem;\n  text-align: center !important;\n}\n\n:host {\n  .modal-header {\n    position: relative;\n    padding-top: 18px;\n\n    .btn-close {\n      position: absolute;\n      top: 16px;\n      right: 16px;\n      cursor: default;\n    }\n\n    .close-custom {\n      justify-content: flex-end;\n      cursor: pointer;\n\n      & :hover {\n        background: none !important;\n      }\n    }\n\n    .sidebar-act-icon {\n      display: flex;\n      color: #707070;\n\n      .sidebar-close {\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n      }\n\n      .sidebar-expand {\n        display: flex;\n        align-items: center;\n        cursor: pointer;\n        margin-right: 1em;\n      }\n    }\n  }\n\n  .modal-body {\n    padding-top: 18px;\n    padding-right: 25px;\n\n    .task-list {\n      table {\n        tbody {\n          height: 245px;\n          overflow-y: auto;\n        }\n      }\n    }\n  }\n\n  .modal-footer {\n    padding-right: 25px;\n    position: sticky;\n    bottom: 0;\n    right: 0;\n    background: #fff;\n    width: 100%;\n    border-top: 1px solid #dee2e6 !important;\n\n    .btn {\n      margin-left: 10px;\n    }\n  }\n}\n\n::ng-deep {\n  #serial-detail-prod {\n    text-align: right;\n\n    .item-wrapper:first-child {\n      text-align: left;\n    }\n\n    .item-wrapper {\n      .content {\n        word-break: break-word !important;\n        overflow-wrap: break-word !important;\n      }\n    }\n  }\n\n  .bold-text {\n    font-weight: 700;\n  }\n\n  .limited-item-table {\n    height: 61vh;\n    //border-right: 1px solid #E8E8E8;\n  }\n\n  .limited-item-table th {\n    position: sticky;\n    top: -1px;\n  }\n\n}\n\n\n.btn {\n  min-width: 115px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
